import { Metamodel } from '../base/model';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { convertObjectToString, format } from 'app/shared/utils/string.util';

import { TabularTypeDataset, IModel, IViolation, IValidationContext, AdapterContext, IAttribute } from 'shell-models-lib';
import { ModelUtilties } from '../services/model-utilities';
import { LoggerService } from 'app/logger/logger.service';
import { getServiceInstance } from 'app/multi-contexts/modules/root/root.application';
import { shouldValidateDeltaTableFormat } from 'app/shared/utils/databricks-dataset.util';
import { DatabricksLinkedService } from '../linkedservice/databricks.linkedservice';

@Metamodel.model({
    name: adfModelTypeMap.databricks.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.Activity_Category_Databricks),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.Activity_Category_Databricks)
    ],
    validator: DatabricksDataset.validateTable,
    constraints: {
        linkedService: {
            model: DatabricksLinkedService.MODEL
        }
    }
})
export class DatabricksDataset extends TabularTypeDataset {
    public static readonly className = 'DatabricksDataset';
    public static readonly MODEL: IModel;
    public static readonly DATABASE: IAttribute;

    public constructor(name?: string, description?: string) {
        super(name, description);
        this.isV2 = true;
    }

    @Metamodel.attribute({
        display: stringResources.DataBricks_Cluster_Unity_Catalog,
        templatable: true,
        association: 'DATABASE',
    })
    public database?: string;

    public static async validateTable(
        dataset: DatabricksDataset,
        context: IValidationContext
    ): Promise<IViolation[] | undefined> {
        type IQueryApiFactoryLike = {
            getMadridQueryApi: () => {
                getTableTypeAsync: (linkedService: unknown, datasetResource: unknown) => Promise<string | undefined>;
            };
        };

        if (
            shouldValidateDeltaTableFormat(adfModelTypeMap.databricks.datasetType) &&
            dataset.linkedService != null &&
            !dataset.linkedService.parameterized &&
            !TabularTypeDataset.TABLE.templateValue(dataset) &&
            !TabularTypeDataset.SCHEMA.templateValue(dataset) &&
            !!dataset.schema &&
            !!dataset.table
        ) {
            try {
                const queryApiFactoryService = await getServiceInstance(context.contextData, 'QueryApiFactoryService') as IQueryApiFactoryLike;
                const tableFormat = await queryApiFactoryService
                    .getMadridQueryApi()
                    .getTableTypeAsync(
                        dataset.linkedService,
                        await ModelUtilties.toResource(AdapterContext.defaultContextOf(context.contextData), dataset)
                    );
                if (tableFormat && tableFormat !== 'delta') {
                    return [
                        {
                            context: dataset,
                            message: () => stringResources.SelectedTableIsNotDelta,
                            doNotAutomaticallyCorrect: true
                        }
                    ];
                }
            } catch (e) {
                const logger = await getServiceInstance<LoggerService>(context.contextData, 'LoggerService');
                logger.error(DatabricksDataset.className, convertObjectToString(e));
            }
        }
        return undefined;
    }
}
